//changes from haseeb.

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { UsePortalApi } from "../../../utils/UsePortalApi";

export const MessageByID = createAsyncThunk(
  "MessageByID",
  async (payload, { dispatch, getState }) => {
    try {
      dispatch(gettingMessageByID(""));
      const response = await UsePortalApi(
        `Patient/MessageByID`,
        "Post",
        payload,
        true
      );
      if (response) {
        console.log(response , "response")
         dispatch(gettingMessageByIDSuccess(response))

      } else {
        dispatch(
          gettingMessageByIDFailed(
            response?.errorMessage
          )
        );
      }
    } catch (error) {
      dispatch(gettingMessageByIDFailed(error));
    }
  }
);
const MessageByIDSlice = createSlice({
  name: "MessageByID",
  initialState: {
    MessageByIDData: null,
    isMessageByIDData: false,
    isMessageByIDError: false,
  },
  reducers: {
    gettingMessageByID: (state, action) => {
      state.MessageByIDData = null;
      state.isMessageByIDData = true;
      state.isMessageByIDError = false;
    },
    gettingMessageByIDSuccess: (state, action) => {
      state.MessageByIDData = action.payload;
      state.isMessageByIDData = false;
      state.isMessageByIDError = false;
    },
    gettingMessageByIDFailed: (state, action) => {
      state.MessageByIDData = null;
      state.isMessageByIDData = false;
      state.isMessageByIDError = true;
    },
    gettingMessageByIDClear: (state, action) => {
      state.MessageByIDData = null;
      state.isMessageByIDData = false;
      state.isMessageByIDError = false;
    },
  },
});
export const {
  gettingMessageByID,
  gettingMessageByIDSuccess,
  gettingMessageByIDFailed,
  gettingMessageByIDClear,
} = MessageByIDSlice.actions;
export default MessageByIDSlice.reducer;
